// Scoped operational notice; independent of the atlas renderer.
(() => {
  const anchor = document.querySelector("#crawlPrefetch");
  if (!anchor) return;
  const notice = document.createElement("span");
  notice.id = "providerAlert";
  notice.setAttribute("role", "status");
  notice.setAttribute("aria-live", "polite");
  notice.hidden = true;
  anchor.after(notice);
  const reasons = {
    TYPESAFE_REPEATED_REQUEST_REJECTIONS: "plusieurs requêtes rejetées par Jev",
    TYPESAFE_IO: "échecs de connexion à Jev"
  };
  async function refresh() {
    try {
      const response = await fetch("api/v1/status", { cache: "no-store", signal: AbortSignal.timeout(8000) });
      if (!response.ok) throw new Error("Status unavailable");
      const status = await response.json();
      const diagnostics = status.providerDiagnostics || {};
      if (status.providerHold) {
        const code = /^TYPESAFE_HTTP_(\d{3})$/.exec(status.providerHold);
        const reason = reasons[status.providerHold] || (code ? `erreur HTTP ${code[1]} de Jev` : "incident du fournisseur Jev");
        const date = new Date(diagnostics.holdSince);
        const since = Number.isFinite(date.getTime()) ? ` depuis le ${date.toLocaleString("fr-FR")}` : "";
        notice.textContent = `Crawl en pause${since} : ${reason}. Intervention nécessaire.`;
      } else {
        const count = Number(diagnostics.quarantinedRequests) || 0;
        notice.textContent = count > 0 ? `${count} requête(s) Jev isolée(s) après rejet ; résultats concernés non vérifiés.` : "";
      }
      notice.hidden = !notice.textContent;
    } catch {
      if (!notice.hidden) notice.textContent = "Statut Jev indisponible ; le dernier incident reste à vérifier.";
    } finally {
      setTimeout(refresh, 10000);
    }
  }
  refresh();
})();
